import toast from 'react-hot-toast/headless';
import { useMedia } from 'react-use';
import { Toast, ToastVariant } from '@hungryroot/components-toast';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import { RecipeBookmarkButton } from '../components/RecipeBookmarkButton/RecipeBookmarkButton';
import { ShareButtonContainer } from '../components/ShareButtonContainer/ShareButtonContainer';

export const useRdpIcons = () => {
  const isDesktop = useMedia(BreakpointQueryLarge, false);

  return ({ id, name, slug }: { id: number; name: string; slug: string }) => {
    const shareButton = (
      <ShareButtonContainer
        title={name}
        text={name}
        url={`${window.location.origin}/recipes/${slug}/`}
        onShareSuccess={() => {
          if (isDesktop) {
            toast(<Toast variant={ToastVariant.Success}>Link copied</Toast>);
          }
        }}
      />
    );

    const bookmarkButton = (
      <RecipeBookmarkButton pairingId={id} pairingName={name} />
    );

    const staticRecipeBookmarkButton = (
      <RecipeBookmarkButton
        pairingId={id}
        pairingName={name}
        size="medium"
        prominence="tertiary"
        style="muted"
      />
    );

    const staticShareButton = (
      <ShareButtonContainer
        title={name}
        text={name}
        size="medium"
        prominence="tertiary"
        style="muted"
        url={`${window.location.origin}/recipes/${slug}/`}
        onShareSuccess={() => {
          if (isDesktop) {
            toast(<Toast variant={ToastVariant.Success}>Link copied</Toast>);
          }
        }}
      />
    );

    return {
      staticRecipeBookmarkButton,
      staticShareButton,
      shareButton,
      bookmarkButton,
    };
  };
};
